module.exports = __webpack_public_path__ + "media/images/page/kodawari02-a67fe8a52e61059e10678097771a92d1.jpg";